import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:max-w-[500px] w-full mx-auto py-6" }

import UserLayout from "@/layouts/UserLayout.vue";
import FormSection from "./FormSection.vue";
import { computed, ref, watch } from "vue";
import DataDictionaryService from "@/classes/Settings/DataDictionaryService";
import { useRoute } from "vue-router"; 
import { useNetworkStore } from "@/store/network";
import { onIonViewWillEnter } from "@ionic/vue"; 
import DataDictionaryOfflineProcessor from "@/classes/DataDictionary/Offline/processor/DataDictionaryOfflineProcessor";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const route = useRoute(); 
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

/**
 * VARIABLES
 */
const form = ref<{ name: string; content: string }>({
	name: "",
	content: "",
});

const getData = async () => {
    const response = await DataDictionaryService.show({
		dataDictionary: route.params.dataDictionary,
	}, {});
    if (response?.status === 200 || response?.data != undefined) {
        const data = response.data; 
        if (isNetworkAvailable.value) {
            await DataDictionaryOfflineProcessor.syncToOffline(data.item);
        }
        form.value.name = data.item.name;
        form.value.content = data.item.content;
    } else {
        console.log(response);
    }
}

watch(
    () => isNetworkAvailable.value,
    async () => {
        await getData();
    }
);

onIonViewWillEnter(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/data-dictionary/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          isReadOnly: true
        }, null, 8, ["form"])
      ])
    ]),
    _: 1
  }))
}
}

})